import axios from '@/util/axios'
import axiosNoError from '@/util/axios_no_error'
import { NEW_API_CONFIG, DEV_API_TOKEN } from '@/util/constants'
import store from '@/store'
import { isFromAdminSystem } from '@/util/common'
import { handleApiError as handleError } from '@/util/axios_common'

/**
 * タグ一覧API
 * @param  {} params={}
 */
export const list = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/TG/001', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/TG/001', r).catch(handleError)
  }
}

/**
 * タグ編集API
 * @param  {} params={}
 */
export const edit = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/TG/002', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/TG/002', r).catch(handleError)
  }
}

/**
 * タグ削除API
 * @param  {} params={}
 */
export const remove = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/TG/003', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/TG/003', r).catch(handleError)
  }
}
